import axios from "axios";

// "https://eshope-alpha.vercel.app"
// // http://127.0.0.1:8080
const baseUrl = axios.create({ baseURL: "https://eshope-server.vercel.app" });

export default baseUrl;
